<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<style lang="scss">
.input-wdt {
  width: 100%;
}
.level-inner-wrap {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.level-inner-wrap .select-level-drop {
  width: 70%;
  margin-right: 15px;
}
.create-category {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.create-category .input-wdt2 {
  width: 80%;
  margin-right: 15px;
}
.con-img-upload {
  background: #efebeb;
}
.ql-container.ql-snow {
  min-height: 150px;
}
.profile-edit .ql-editor {
  min-height: 150px;
}
.countDivder {
  margin: 30px 0 0;
}
.rqrd {
  color: #f00;
}

.profile-edit{display:flex;}
.profile-edit .unlayer-editor{width: 100%}
</style>
<template>
  <div id="page-edit-tab-account">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mt-2">
        <label>
          Name
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="inputx w-full"
          name="Name"
          v-model="data_local.Name"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Name')"
        >{{ errors.first('Name') }}</span>
      </div>
      <div class="vx-col md:w-3/12 w-full mt-2">
        <label>
          Venue
          <!-- <span class="rqrd">*</span> -->
        </label>
        <v-select
          autocomplete="off"
          class="w-full"
          v-model="data_local.Venue"
          name="Venue"
          :clearable="true"
          label="Name"
          :options="VenueList"
        />
        <!-- <span
          class="text-danger text-sm"
          v-show="errors.has('Name')"
        >{{ errors.first('Name') }}</span> -->
      </div>
      <div class="vx-col md:w-3/12 w-full mt-2">
        <label>
          Display Order
        </label>
        <vs-input-number
          type="number"
          class="inputx w-full"
          v-model="data_local.FlooreMapDisplayOrder"
        />
      </div>
      
      <div class="vx-col md:w-1/2 w-full mt-4">
        <div class="flex items-center flex-col sm:flex-row">
          <div class="mr-4" v-if="data_local.MapImage">
            <img :src="data_local.MapImage" class="" style="width:100%;height;40px" />
          </div>
          <div>
            <p>Dimension should be 1072 X 988 or greater</p>
            <input
              id="uploadAvatar"
              type="file"
              ref="update_avatar_input"
              @change="update_avatar($event, '1072x988')"
              accept="image/*"
            />
          </div>
        </div>
      </div>

    </div>

    

    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
        <vs-button class=" mt-2" @click="$router.push('/event/floormaps')">Back To List</vs-button>
          <vs-button
            class="ml-auto mt-2"
            @click="before_save"
            :disabled="!validateForm"
          >Save Changes</vs-button>
          <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset_data">Reset</vs-button>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";

import ls from "@/common/localStorage"

import moduleVenueManagement from "@/store/venue-management/moduleManagement.js";

var cn = ls.getSessionEventCollectionName();
var Session_Client_Id = ls.getSessionValueByKey("Session_Client_Id")
var vm;
export default {
  components: {
    vSelect,
  },
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      data_local: JSON.parse(JSON.stringify(this.data)),
      VenueList: []
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    update_avatar(input, fileDimension) {      
      if (input.target.files && input.target.files[0]) {
        let file = input.target.files[0];
        var metadata = {
          contentType: file.type,
        };

        let validImageTypes = ["image/gif", "image/jpeg", "image/png"];
        if (!validImageTypes.includes(file.type)) {
          alert("Only gif,jpeg & png file allowed.");
          return false;
        }

        let dimension = fileDimension.split("x");
        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var objectUrl = _URL.createObjectURL(file);
        img.onload = function () {
          if (this.width >= dimension[0] && this.height >= dimension[1]) {
            const reader = new FileReader();
            reader.onload = (e) => {
              let fileBlob = e.target.result;
              vm.uploadServerImage(fileBlob, `${cn}/Floormaps/Images/`, file, {width:this.width, height:this.height})
            };
            reader.readAsDataURL(input.target.files[0]);
            //reader.readAsText(input.target.files[0]);
            
          } else {
            alert("File dimension does not match " + fileDimension);
            return false;
          }
          _URL.revokeObjectURL(objectUrl);
        };
        img.src = objectUrl;

      }
    },
    uploadServerImage(fileBlob, target, file, WHObj = null) {
      this.$vs.loading();
      this.$store
        .dispatch("floorMapManagement/uploadFiles", [
          { blob: fileBlob, target: target, name: file.name, type: file.type },
        ])
        .then((res) => {
          this.$vs.loading.close();
          if (res.data.length && res.data[0].status == "fulfilled") {
            this.data_local.MapImage = res.data[0].value.url;
            if(WHObj){
              this.data_local.TotalWidth = WHObj.width;
              this.data_local.TotalHeight = WHObj.height;
            }
          } else {
            this.$vs.notify({
              color: "warning",
              position: "top-center",
              //title: "Session",
              text: "File not uploaded!",
            });
          }
        })
        .catch((err) => {
          this.$vs.loading.close();
          this.$vs.notify({
            color: "warning",
            position: "top-center",
            //title: "Session",
            text: "Something went wrong!",
          });
        });
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },
    async save_changes() {
      /* eslint-disable */
      if (!this.validateForm) return;

      this.$vs.loading();
      const Id = this.$route.params.id;
      //alert(Id);
      if (Id) {
          this.$store
            .dispatch("floorMapManagement/updateFloorMap", {
              id: Id,
              data: this.data_local,
            })
            .then((res) => {
              //alert(res.message)
              this.$vs.notify({
                color: "success",
                position: "top-center",
                //title: "Page",
                text: "Data updated successfully.",
              });
              this.$vs.loading.close();
            })
      } else {
        if(this.data_local.MapImage){
          this.$store
            .dispatch("floorMapManagement/addFloorMap", { data: this.data_local })
            .then((res) => {
              this.$vs.notify({
                color: "success",
                position: "top-center",
                //title: "Page",
                text: "Data added successfully.",
              });
              this.$vs.loading.close();
              if (res.status == 200) {
                this.$router.push("/event/floormaps");
              }
            })
        }else{
          await this.$vs.notify({
            color: "warning",
            position: "top-center",
            //title: "Page",
            text: "Please upload proper image!",
          });
          this.$vs.loading.close();
        }
      }
    },
    reset_data() {
      this.data_local = JSON.parse(JSON.stringify(this.data));
    },
    getVenues(){
      this.$store.dispatch("venueManagement/fetchVenues").then(res=>{
        this.VenueList = res.filter(item=> item.IsPublished);
      })
    }
    
  },
  mounted(){
    vm = this;
  },
  created() {
    if (!moduleVenueManagement.isRegistered) {
      this.$store.registerModule("venueManagement", moduleVenueManagement);
      moduleVenueManagement.isRegistered = true;
    }
    this.getVenues();
  },
};
</script>
